import { render, staticRenderFns } from "./MemberCertGet.vue?vue&type=template&id=37b351fa&scoped=true&"
import script from "./MemberCertGet.vue?vue&type=script&lang=js&"
export * from "./MemberCertGet.vue?vue&type=script&lang=js&"
import style0 from "./MemberCertGet.vue?vue&type=style&index=0&id=37b351fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b351fa",
  null
  
)

export default component.exports